import React from 'react'
import '../../pages/viewUser/viewUser.css'
import { useLocation } from 'react-router-dom';

const ViewVideoStatistics = () => {
    const users = [
        {
            id: "0000001",
            phoneNumber: "1234567890",
            country: "India",
            gender: "Male",
            ageGroup: "Upto 18",
            joiningDate: '1-Jan-2003',
            lastDateActive: '12-Jul-2024',
            nameOfMentor: 'Jack',
            completedStory: '13',
            rank: '1st',
            city: 'Surat',
            totalMsg: '200',
            lastMsgOn: '11-jul-2024',
            status: "Active",
        },
        {
            id: "0000002",
            phoneNumber: "1234567890",
            country: "USA",
            gender: "Female",
            ageGroup: "19-30",
            joiningDate: '1-Jan-2003',
            lastDateActive: '12-Jul-2024',
            nameOfMentor: 'Jack',
            completedStory: '14',
            rank: '1st',
            city: 'Surat',
            totalMsg: '200',
            lastMsgOn: '11-jul-2024',
            status: "Inactive",
        },
        {
            id: "0000003",
            phoneNumber: "1234567890",
            country: "Russia",
            gender: "Male",
            ageGroup: "31-50",
            joiningDate: '1-Jan-2003',
            lastDateActive: '12-Jul-2024',
            nameOfMentor: 'Jack',
            completedStory: '15',
            rank: '1st',
            city: 'Surat',
            totalMsg: '200',
            lastMsgOn: '11-jul-2024',
            status: "Active",
        },
    ];

    const location = useLocation()

    return (
        <div className="container mb-5">
            <div className="overview d-flex align-items-center justify-content-between">
                <div className="title">
                    <ion-icon name="eye-outline"></ion-icon>
                    <span className="text">View video statistics</span>
                </div>
            </div>

            <div className="mt-4">
                <div className="userInfo">
                    <label>Story</label>
                    <div>{location.state}</div>
                </div>
                <div className="userInfo mt-4">
                    <label>Number of time watch</label>
                    <div>10</div>
                </div>
                <div className="userInfo mt-4">
                    <label>Average length of view</label>
                    <div>500</div>
                </div>
                <div className="userInfo mt-4">
                    <label>Number of viewers</label>
                    <div>750</div>
                </div>
                <div className="userInfo mt-4">
                    <label>Demographics of viewers</label>
                    <div className="data-table activityTable mt-2">
                        <div className="tableStyle mb-5">
                            <table>
                                <thead>
                                    <tr>
                                        <th className="users-th">Id</th>
                                        <th className="users-th">Phone number</th>
                                        <th className="users-th" style={{ width: '109px' }}>Completed stories</th>
                                        <th className="users-th">Signup date</th>
                                        <th className="users-th">Last date active</th>
                                        <th className="users-th">Country</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users.map((user, index) => (
                                        <tr>
                                            <td className="users-td" key={index}>
                                                {user.id}
                                            </td>
                                            <td className="users-td">
                                                <div>{user.phoneNumber}</div>
                                            </td>
                                            <td className="users-td">{user.completedStory}</td>
                                            <td className="users-td">{user.joiningDate}</td>
                                            <td className="users-td">{user.lastDateActive}</td>
                                            <td className="users-td">India</td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ViewVideoStatistics